<template>
  <ValidationObserver
    ref="obs"
    v-slot="{ valid, handleSubmit }">
    <v-form
      v-model="valid"
      @submit.prevent="handleSubmit(submit)">
      <v-row>
        <v-col>
          <validation-input
            v-model="item.name"
            rules="required|min:3|max:50"
            label="Nom" />
        </v-col>
        <v-col>
          <v-menu
            ref="menu"
            v-model="menu"
            :close-on-content-click="false"
            :return-value.sync="item.date"
            transition="scale-transition"
            offset-y
            max-width="290px"
            min-width="290px">
            <template #activator="{ on, attrs }">
              <v-text-field
                v-model="item.date"
                label="date"
                readonly
                v-bind="attrs"
                v-on="on" />
            </template>
            <v-date-picker
              v-model="item.date"
              type="date"
              no-title
              scrollable>
              <v-spacer />
              <v-btn
                text
                color="primary"
                @click="menu = false">
                Cancel
              </v-btn>
              <v-btn
                text
                color="primary"
                @click="$refs.menu.save(item.date)">
                OK
              </v-btn>
            </v-date-picker>
          </v-menu>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <v-select
            v-model="item.mode"
            :items="discountModes"
            item-text="text"
            item-value="mode"
            label="Mode" />
        </v-col>
        <v-col>
          <validation-input
            v-model="item.value"
            rules="required"
            type="number"
            min="0"
            label="Montant" />
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <v-select
            v-model="item.code"
            :items="billingItemList"
            item-text="name"
            item-value="pk"
            label="Article"
            :disabled="!canSelectItem" />
        </v-col>
      </v-row>
      <!--      <v-row>-->
      <!--        <v-col>-->
      <!--          <v-textarea label="Infos" v-model="item.info"></v-textarea>-->
      <!--        </v-col>-->
      <!--      </v-row>-->
      <v-btn
        type="submit"
        color="success"
        class="mr-4">
        Valider
      </v-btn>
    </v-form>
  </ValidationObserver>
</template>

<script>
  import moment from 'moment'

  const emptyItem = {
    account: null,
    date: null,
    value: null,
    info: null,
    name: null,
    mode: 'VALUE'
  }
  export default {
    name: 'DiscountForm',
    props: {
      source: {
        type: Object,
        required: false
      },
      accountPk: {
        type: String,
        required: false
      }
    },
    data () {
      return {
        menu: false,
        discountModes: [
          {
            mode: 'PERCENTAGE',
            text: 'Pourcentage (%)'
          },
          {
            mode: 'VALUE',
            text: 'Valeur (€)'
          }
        ],
        item: {},
        billingItemList: [],
        billingAccount: null
      }
    },
    computed: {
      canSelectItem () {
        return this.item.mode === 'PERCENTAGE'
      }
    },
    created () {
      this.fetchBillingAccount()
      this.fetchArticles()
      if (this.source) {
        this.item = Object.assign({}, this.source)
      } else {
        this.item = Object.assign({}, emptyItem)
        this.item.account = this.accountPk
      }
    },
    methods: {
      async fetchBillingAccount () {
        let { data } = await this.$billingApi.get(`/accounts/${this.accountPk}`)
        this.billingAccount = data
      },
      async fetchArticles () {
        let { data } = await this.$billingApi.get(`/items`)
        this.billingItemList = data.items
      },
      async submit () {
        let payload = Object.assign({}, this.item)
        if (this.item.date) {
          payload.date = moment(this.item.date).toISOString()
        } else {
          delete payload.date
        }
        if (!this.item.code) {
          delete payload.code
        }
        console.log(payload)
        try {
          if (this.source) {
            await this.$billingApi.put(`/discounts/${this.item.pk}`, payload)
          } else {
            await this.$billingApi.post(`/discounts`, payload)
          }
          this.$awn.success('Remise créé')
          await this.$router.replace({
            name: 'accountVue',
            params: { id: this.billingAccount.external_pk, tab: { title: 'Reduction' } }
          })
        } catch (err) {
          console.log(err)
        }
      }
    }
  }
</script>

<style scoped>

</style>
